import classnames from 'classnames';
import { PropTypes } from 'prop-types';
import React from 'react';
import HrbTranslate from '../../language/HrbTranslate';
import './Buttons.scss';

const Button = ({ elementId, labelKey, children, buttonStyles, textLast, disabled, onClick, loading, tabIndex, truncateText, params }) => {

    const click = e => {
        if (onClick && !disabled) {
            onClick(e)
        }
    }

    return (
        <button className={classnames("button", buttonStyles, { 'is-loading': Boolean(loading) }, { 'disabled': Boolean(disabled) })}
            id={elementId} tabIndex={tabIndex}
            onClick={click}>
            {(textLast && children) && children}
            {labelKey &&
                <HrbTranslate text={labelKey} truncateText={truncateText} params={params} />
            }
            {(!textLast && children) && children}
        </button>
    );
};

Button.propTypes = {
    elementId: PropTypes.string.isRequired,
    labelKey: PropTypes.string, 
    children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]), 
    tabIndex: PropTypes.number,
    disabled: PropTypes.bool,
    onClick: PropTypes.func,
    buttonStyles: PropTypes.string.isRequired,
    loading: PropTypes.bool,
    truncateText: PropTypes.bool,
    params: PropTypes.object
};

export default Button;